import { Component, OnInit, Input, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";

//import { GridApi, GridOptions, AllModules } from '@ag-grid-enterprise/all-modules';
import { GridApi, GridOptions } from "ag-grid-community";
import { GridFormatterService } from "../../../../common/services/grid-formatter.service";
import { WellSegmentModel } from "../models/casing-plan.model";


@Component({
    selector: "well-segment-precis",
    templateUrl: "./well-segment-precis.component.html",
    styleUrls: ["../new-casing-plan.component.scss"],
    standalone: false
})
export class WellSegmentPrecisComponent implements OnInit {

    @Input() segmentChanged: EventEmitter<WellSegmentModel>;
    @Input() wellSegment: WellSegmentModel;

    segmentColumnDefs = [
        {
            headerName: "Casing Type",
            field: "casingType"
        },
        {
            headerName: "Condition",
            field: "casingCondition"
        },        
        {
            headerName: "Casing Diameter",
            field: "diameter"
        },
        {
            headerName: "Casing Length",
            field: "length"
        },
        {
            headerName: "Cement Volume",
            field: "cementVolume"
        }
    ];
    segmentData = [];
    segmentGridApi: GridApi;
    segmentGridOptions: GridOptions;


	constructor(private _formatter: GridFormatterService) { }   

    ngOnChanges(changes: SimpleChanges) {
        if (changes["wellSegment"]) {
            this.parseSegmentData();
        }
    }

    ngOnInit() {
        this.parseSegmentData();
        if (this.segmentChanged) {
            this.segmentChanged.subscribe((update) => {
                if (update) {
                    this.wellSegment = update;
                    this.parseSegmentData();
                }
            });
        }        
    }

    parseSegmentData(): void {
        this.segmentData = [];
        if (this.wellSegment) {
            this.segmentData.push({
                casingType: this.wellSegment.casingType.definition,
                casingCondition: this.wellSegment.casingCondition.name,
                drillingEquipment: this.wellSegment.drillingEquipment.definition,
                diameter: this.wellSegment.casingDiameter,
                length: this.wellSegment.casingLength,
                cementVolume: this.wellSegment.cementVolume
            });
            if (this.segmentGridApi) {
                this.segmentGridApi.setGridOption("rowData", this.segmentData);
                this.segmentGridApi.sizeColumnsToFit();
            }       
        }        
    }

    segmentGridOnReady(params): void {
        this.segmentGridApi = params.api;
        this.segmentGridApi.sizeColumnsToFit();
        this.segmentGridApi.refreshCells();
    }

}
